import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { useRef as r, useState as t, useMemo as i, useEffect as n, useCallback as a } from "react";
import { useVirtualizer as s } from "../../../../node_modules/@tanstack/react-virtual/dist/esm/index.js";
import l from "../../../../node_modules/lodash-es/find.js";
import m from "../../../../node_modules/lodash-es/get.js";
import d from "../../../../node_modules/lodash/debounce.js";
import { useClickOutside as c } from "../../../hooks/useClickOutside.js";
import u from "@mui/icons-material/Search";
import { styled as p, Sheet as h } from "@mui/joy";
import f from "@mui/joy/List";
import g, { listItemClasses as v } from "@mui/joy/ListItem";
import x from "@mui/joy/ListItemButton";
import j from "@mui/joy/Stack";
import F from "@mui/material/CircularProgress";
import { NotFoundListItem as N } from "./components/NotFoundListItem.js";
import { OpenButton as C } from "./components/OpenButton.js";
import { PopupContainer as L } from "./components/PopupContainer.js";
import { PopupHeader as T } from "./components/PopupHeader.js";
import { useDeepCompareMemo as b } from "../../../hooks/useDeepCompareMemo.js";
import { useUpdateEffect as S } from "../../../hooks/useUpdateEffect.js";
import { FormLabel as I } from "../../FormLabel.js";
import { FormErrorMessage as O } from "../../FormErrorMessage.js";
import { BaseInput as k } from "../../BaseStyledComponents/BaseInput.js";
const w = p("div")(({ theme: e2 }) => ({ margin: `${e2.spacing(1.2)}` })), y = p(x)(({ theme: e2 }) => ({ color: e2.palette.isDarkMode ? e2.palette.neutral[900] : "inherit" })), D = { height: 150, overflow: "auto", background: "none", [`& .${v.root}`]: { padding: 0, fontSize: "14px" }, paddingTop: "4px" }, M = (e2, o2) => o2.find((o3) => m(e2, o3.formFieldName)) ?? o2.find((e3) => !e3.disabled) ?? o2[0], P = ({ control: p2, label: v2, placeholder: x2 = "Оберіть зі списку", required: P2 = false, disabled: z, variants: E, hideError: V = false, hideVariantSelector: B = false, caseInsensitive: $ = false, width: _, resetOnFieldChange: q, onChange: A }) => {
  const H = r(null), R = r(null), U = r(null), [Y, G] = t(false), J = r(true), K = E.map(({ options: e2, hasNextPage: o2, onLoadMore: r2, isOptionsDataLoading: t2, searchText: i2, onSearchTextChange: n2, ...a2 }) => a2), Q = b(() => K, [K]), W = i(() => E.reduce((e2, o2) => (e2[o2.formFieldName] = { options: o2.options, hasNextPage: o2.hasNextPage, onLoadMore: o2.onLoadMore, isOptionsDataLoading: o2.isOptionsDataLoading, searchText: o2.searchText, onSearchTextChange: o2.onSearchTextChange }, e2), {}), [E]), X = i(() => Q.map((e2) => e2.formFieldName), [Q]), [Z, ee] = t(() => M(p2.values, Q)), [oe, re] = t([]), [te, ie] = t(null), [ne, ae] = t(""), { formFieldName: se } = Z, { searchText: le, options: me, hasNextPage: de, onLoadMore: ce, isOptionsDataLoading: ue, onSearchTextChange: pe } = W[se];
  n(() => {
    J.current ? J.current = false : G(false);
  }, [Q.length]);
  const he = i(() => q ? m(p2.values, q) : void 0, [p2.values, q]);
  n(() => {
    q && (G(false), ie(null), ae(""), ee(M(p2.values, Q)));
  }, [he, q, p2.values, Q]), n(() => {
    pe == null ? void 0 : pe("");
  }, [pe]), S(() => {
    ee(M(p2.values, Q));
  }, [p2.values, Q]), n(() => {
    re(me);
  }, [me]), n(() => {
    const e2 = m(p2.values, Z.formFieldName);
    if (e2) {
      const o2 = l(me, ["id", e2]);
      o2 && ie(o2);
    }
  }, [p2.values, Z, me]);
  const fe = oe.length, ge = s({ count: le && ue || !ue && 0 === fe ? 1 : de ? fe + 1 : fe, estimateSize: () => 32, getScrollElement: () => U.current, overscan: 5 }), ve = ge.getVirtualItems(), xe = ge.getTotalSize();
  n(() => {
    const [e2] = [...ve].reverse();
    if (!e2) return;
    e2.index >= fe - 1 && de && !ue && Y && (ce == null ? void 0 : ce());
  }, [ve, fe, ce, Y, de, ue]), c(H, () => {
    G(false), pe == null ? void 0 : pe(""), ae(""), pe || re(me), ge.scrollToIndex(0);
  }), n(() => {
    if (!Y) return;
    const e2 = requestAnimationFrame(() => {
      U.current && (U.current.scrollTop = 0), ge.scrollToIndex(0);
    });
    return () => cancelAnimationFrame(e2);
  }, [Y, ge]);
  const { values: je, errors: Fe, touched: Ne, setFieldValue: Ce } = p2, Le = i(() => d((e2) => pe == null ? void 0 : pe(e2), 200), [pe]), Te = a((e2) => {
    ie(e2), Ce(Z.formFieldName, e2.id);
    for (const e3 in je) Z.formFieldName.includes(e3) && X.forEach((e4) => {
      e4 !== Z.formFieldName && Ce(e4, null);
    });
    G(false), pe == null ? void 0 : pe(""), ae(""), pe || re(me), A == null ? void 0 : A(e2.id);
  }, [Z.formFieldName, X, Ce, je, pe, me, A]), be = i(() => m(Fe, Z.formFieldName), [Z.formFieldName, Fe]), Se = i(() => be && m(Ne, Z.formFieldName), [be, Ne, Z.formFieldName]), Ie = !!le && ue, Oe = !P2 && 1 === oe.length, ke = 0 === oe.length && !ue || Oe, we = a((r2) => {
    const t2 = Ie || r2 > oe.length - 1;
    if (ke) return e(g, { sx: { height: 32 }, children: e(N, {}) });
    if (t2) return o(g, { sx: { height: 32 }, children: [e(F, { size: 20 }), " Завантаження..."] }, r2);
    const i2 = oe[r2], n2 = te && te.id === i2.id;
    return e(g, { sx: { height: 32 }, children: e(y, { onClick: () => Te(i2), disabled: n2, children: i2.value }) }, i2.id);
  }, [Ie, ke, oe, te, Te]);
  return o("div", { ref: H, children: [e(j, { direction: "row", justifyContent: "space-between", alignItems: "center", children: v2 && e(I, { required: P2, disabled: z, children: v2 }) }), e(C, { buttonRef: R, isOpen: Y, setIsOpen: G, label: te == null ? void 0 : te.value, placeholder: x2, disabled: z, hasError: !!Se }), Se && !V && e(O, { sx: { marginTop: 1 }, children: be }), o(L, { buttonRef: R, width: _, isOpen: Y, children: [e(w, { children: !B && e(T, { setIsOpen: G, variants: Q, currentVariant: Z, onSelectVariant: (e2) => {
    ae(""), ee(e2), re(me), ge.scrollToIndex(0);
  } }) }), e(w, { children: e(k, { placeholder: "Пошук", startDecorator: e(u, {}), value: ne, onChange: (e2) => {
    const o2 = e2.target.value;
    if (ae(o2), pe) return void Le(o2);
    if (ae(o2), 0 === o2.length) return void re(me);
    const r2 = me.filter((e3) => {
      const r3 = $ ? e3.value.toLowerCase() : e3.value, t2 = $ ? o2.toLowerCase() : o2;
      return r3.includes(t2);
    });
    re(r2);
  } }) }), e(h, { variant: "plain", sx: D, ref: U, component: "div", children: e(f, { size: "sm", sx: { overflow: "hidden", position: "relative", height: xe, minHeight: xe }, component: "div", children: ve.map((o2) => {
    const r2 = { height: `${o2.size}px`, left: 0, position: "absolute", top: 0, transform: `translateY(${o2.start}px)`, width: "100%", paddingLeft: "8px" };
    return e("div", { style: r2, children: we(o2.index) }, o2.key);
  }) }) })] })] });
};
export {
  P as SelectSearchFieldDynamic
};
//# sourceMappingURL=SelectSearchFieldDynamic.js.map
